// src/pages/Batches/components/tables/BatchSummaryTab.tsx
import React from 'react';
import DefaultCard from '../../../../components/default/DefaultCard';
import { BatchDataForm } from '../../../../app/models/Batch';

interface Props {
  batch: BatchDataForm;
}

const BatchSummaryTab: React.FC<Props> = ({ batch }) => {
  
  // Formatear números con separador de miles
  const formatNumber = (value: number | string | undefined | null): string => {
    if (value === null || value === undefined || value === '') return '0,00';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Calcular valor total si no existe pero hay precio unitario y cantidad
  const getTotalValue = (): string => {
    if (batch.total_value) {
      return formatNumber(batch.total_value);
    }
    if (batch.unit_price && batch.quantity) {
      const total = Number(batch.unit_price) * Number(batch.quantity);
      return formatNumber(total);
    }
    return '0,00';
  };

  // Obtener unidad del precio
  const getPriceUnit = (): string => {
    if (batch.price_unit && batch.price_currency) {
      return `${batch.price_currency}/${batch.price_unit}`;
    }
    if (batch.price_currency) {
      return batch.price_currency;
    }
    if (batch.price_unit) {
      return batch.price_unit;
    }
    return '-';
  };

  // Obtener unidad de cantidad
  const getQuantityUnit = (): string => {
    return batch.unit || '-';
  };

  // Obtener moneda del valor total
  const getTotalCurrency = (): string => {
    return batch.total_value_currency || batch.price_currency || '-';
  };

  // Formatear fecha de cosecha
  const formatHarvestDate = (): string => {
    if (!batch.harvest_date) return '-';
    try {
      const date = new Date(batch.harvest_date);
      return date.toLocaleDateString('es-CL', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      });
    } catch {
      return batch.harvest_date.toString();
    }
  };

  return (
    <>
      <DefaultCard>
        <h5 className="mb-3">Resumen del lote</h5>
        
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="table-light">
              <tr>
                <th style={{ width: '40%' }}>Dato</th>
                <th style={{ width: '30%', textAlign: 'right' }}>Valor</th>
                <th style={{ width: '30%' }}>Unidad</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Cantidad</strong></td>
                <td style={{ textAlign: 'right' }}>{formatNumber(batch.quantity)}</td>
                <td>{getQuantityUnit()}</td>
              </tr>
              <tr>
                <td><strong>Precio Un</strong></td>
                <td style={{ textAlign: 'right' }}>
                  {batch.unit_price ? formatNumber(batch.unit_price) : '-'}
                </td>
                <td>{getPriceUnit()}</td>
              </tr>
              <tr>
                <td><strong>Valor Total</strong></td>
                <td style={{ textAlign: 'right' }}>{getTotalValue()}</td>
                <td>{getTotalCurrency()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </DefaultCard>

      <div className="mt-3">
        <DefaultCard>
          <h5 className="mb-3">Información adicional</h5>
          
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '50%' }}>Campo</th>
                  <th style={{ width: '50%' }}>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Fecha de Cosecha</strong></td>
                  <td>{formatHarvestDate()}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultCard>
      </div>
    </>
  );
};

export default BatchSummaryTab;

